export interface Evaluation {
  assessmentEvaluation?: AssessmentEvaluation;
  teachingEvaluation?: TeachingEvaluation;
  industryEvaluation?: IndustryEvaluation;
  approvalSubjects: ApprovalSubject[];
}

export interface AssessmentEvaluation {
  makingAssessmentFurtherEvidenceText?: string;
  standardSettingFurtherEvidenceText?: string;
  designingDevelopingAssessmentFurtherEvidenceText?: string;
  evaluatingAssessmentsFurtherEvidenceText?: string;
  rejectedReason?: string;
  subjectDescriptions: AssessmentEvaluationNote;
}

export interface AssessmentEvaluationNote{
  makingAssessmentFurtherEvidenceGeneratedNote?: string;
  standardSettingFurtherEvidenceGeneratedNote?: string;
  designingDevelopingAssessmentFurtherEvidenceGeneratedNote?: string;
  evaluatingAssessmentsFurtherEvidenceGeneratedNote?: string;
  industryFurtherEvidenceNote?: string;
  teachingLecturingFurtherEvidenceGeneratedNote?: string;
  trainingFurtherEvidenceGeneratedNote?: string;
  educationManagementFurtherEvidenceGeneratedNote?: string;
  teacherTrainingFurtherEvidenceGeneratedNote?: string;
}

export interface IndustryEvaluation {
  industryAssessmentFurtherEvidenceText?: string;
  rejectedReason?: string;
  subjectDescriptions: AssessmentEvaluationNote;
}

export interface TeachingEvaluation {
  teachingLecturingAssessmentFurtherEvidenceText?: string;
  trainingAssessmentFurtherEvidenceText?: string;
  educationManagementAssessmentFurtherEvidenceText?: string;
  teacherTrainingAssessmentFurtherEvidenceText?: string;
  rejectedReason?: string;
  subjectDescriptions: AssessmentEvaluationNote;
}

export interface ApprovalSubject {
  subjectId: string;
  levels: ApprovalLevel[];
}

export enum ApprovalStatus {
  Rejected = 0,
  Approved = 1,
  FurtherEvidence = 2,
}

export interface ApprovalLevel {
  levelId: number;
  evaluationResults: EvaluationResults;
}

export type EvaluationResult = {
  approvalStatus?: ApprovalStatus;
};

export type EvaluationResults = {
  makingAssessment: EvaluationResult;
  standardSetting: EvaluationResult;
  designingDevelopingAssessments: EvaluationResult;
  evaluatingAssessments: EvaluationResult;
  teachingLecturingAssessment: EvaluationResult;
  trainingAssessment: EvaluationResult;
  educationManagementAssessment: EvaluationResult;
  teacherTrainingAssessment: EvaluationResult;
  industryAssessment: EvaluationResult;
};
